import { UserRoles } from 'api/services/user/types';

const translateRoles = (role?: string) => {
	switch (role) {
		case UserRoles.SU:
			return 'Супер пользователь';
		case UserRoles.ADMIN:
			return 'Администратор';
		case UserRoles.USER:
			return 'Пользователь';
		default:
			return '';
	}
};

export default translateRoles;
